import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFun } from '../../../../utils/fetchFun';


// export const fetchStockHoldersEquity = createAsyncThunk(
//     'user/fetchStockHoldersEquity',
//     async (userId) => {
//       try{
//         const myHeaders = new Headers();
//         myHeaders.append("Content-Type", "application/json");

//         const requestOptions = {
//           method: "GET",
//           headers: myHeaders,
//           redirect: "follow"
//         };
    
//         const responseRaw = await fetch(`${process.env.REACT_APP_API_KEY}/api/v1/equityholder-statement?userId=${userId}`, requestOptions);
//         if(responseRaw.ok){
//           const response = await responseRaw.json();
//           console.log("response", response)
//             return response?.data;
//         }
//       } catch (error) {
//         console.log("Error - /equityholder-statement", error)
//       }
//     }
// );

export const fetchStockHoldersEquity = createAsyncThunk(
    'user/fetchStockHoldersEquity',
    async ({user}) => {
      try{
        // console.log('UserSession', user);
        const sesData = await fetchFun(`/api/v1/equityholder-statement?userId=${user?._id}`);
        if(sesData?.success) {
          return sesData.data
        }
      } catch (error) {
        console.log("Error - /equityholder-statement", error)
      }
    }
);